import React from 'react';
import { UserPlus, Search, FileText, CheckCircle } from 'lucide-react';
export const HowItWorks = () => {
  const steps = [{
    id: 1,
    title: 'Create an Account',
    description: 'Register for a free account to access all government services',
    icon: <UserPlus className="h-10 w-10 text-blue-600" data-id="element-41" />
  }, {
    id: 2,
    title: 'Find a Service',
    description: 'Search or browse for the service you need',
    icon: <Search className="h-10 w-10 text-blue-600" data-id="element-42" />
  }, {
    id: 3,
    title: 'Fill Application',
    description: 'Complete the required forms and submit your application',
    icon: <FileText className="h-10 w-10 text-blue-600" data-id="element-43" />
  }, {
    id: 4,
    title: 'Get Approval',
    description: 'Receive updates and get your service delivered',
    icon: <CheckCircle className="h-10 w-10 text-blue-600" data-id="element-44" />
  }];
  return <section className="py-16 bg-gray-50" data-id="element-45">
      <div className="container mx-auto px-4" data-id="element-46">
        <div className="text-center mb-12" data-id="element-47">
          <h2 className="text-3xl font-bold mb-4" data-id="element-48">How It Works</h2>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-49">
            Getting government services has never been easier. Follow these
            simple steps to access the services you need.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-50">
          {steps.map(step => <div key={step.id} className="flex flex-col items-center text-center" data-id="element-51">
              <div className="relative" data-id="element-52">
                <div className="flex items-center justify-center w-20 h-20 bg-blue-100 rounded-full mb-6" data-id="element-53">
                  {step.icon}
                </div>
                {step.id < steps.length && <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 bg-blue-200" data-id="element-54"></div>}
              </div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-55">{step.title}</h3>
              <p className="text-gray-600" data-id="element-56">{step.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};